/* ═══════════════════════════════════════════
   ZURI ELEMENTS — Main JS
   Scroll reveal · Accordions · Dropdown
═══════════════════════════════════════════ */

// ── Scroll Reveal ──
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

document.querySelectorAll('.ze-reveal').forEach(el => revealObserver.observe(el));

// ── Header scroll shadow ──
window.addEventListener('scroll', () => {
  document.querySelector('.header-solid')?.classList.toggle('scrolled', window.scrollY > 10);
});

// ── Dropdown ──
function toggleDropdown(btn) {
  const isOpen = btn.classList.contains('open');
  // close all others
  document.querySelectorAll('.nav-dropdown__btn.open').forEach(b => {
    if (b !== btn) {
      b.classList.remove('open');
      b.nextElementSibling.classList.remove('open');
    }
  });
  btn.classList.toggle('open', !isOpen);
  btn.nextElementSibling.classList.toggle('open', !isOpen);
  if (!isOpen) {
    const close = (e) => {
      if (!btn.closest('.nav-dropdown').contains(e.target)) {
        btn.classList.remove('open');
        btn.nextElementSibling.classList.remove('open');
        document.removeEventListener('click', close);
      }
    };
    setTimeout(() => document.addEventListener('click', close), 0);
  }
}

// ── Product & Footer Accordions ──
function toggleAccordion(btn) {
  const content = btn.nextElementSibling;
  const icon = btn.querySelector('.product-accordion__icon, .icon');
  const isOpen = content.classList.contains('open');
  // close siblings
  btn.closest('.product-accordions, footer')?.querySelectorAll('.product-accordion__content.open, .footer__accordion-content.open').forEach(c => {
    c.classList.remove('open');
    const sibIcon = c.previousElementSibling?.querySelector('.product-accordion__icon, .icon');
    if (sibIcon) sibIcon.textContent = '+';
  });
  content.classList.toggle('open', !isOpen);
  if (icon) icon.textContent = isOpen ? '+' : '−';
}

// Auto-attach footer accordions
document.querySelectorAll('.footer__accordion-btn').forEach(btn => {
  btn.addEventListener('click', () => toggleAccordion(btn));
});

// ── Re-run reveal on dynamic content ──
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ze-reveal').forEach(el => revealObserver.observe(el));
});
